import { Component, HostBinding, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/core/services/environment/environment.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { ApplicationContext, ContactListType, LoanStatus, RecentAgent, RecentBorrower, RecentLead, SmsChatRequestedModel, UserProfile } from 'src/app/models';
import { AlertModel } from 'src/app/models/alert.model';
import { LoanDocDashboardTask } from 'src/app/models/borrower/loan-doc-dashboard-task.model';
import { MentionMessageScope } from 'src/app/models/mention.model';
import { ApplicationContextService } from 'src/app/services/application-context.service';
import { FirebaseService } from 'src/app/services/firebase';
import { NotificationService } from 'src/app/services/notification.service';
import { SignalRService } from 'src/app/services/signalr.service';
import { LoanUpdateCoordinatorService } from 'src/app/services/loan-update-coordinator.service';
import { TaskService } from 'src/app/services/task.service';
import { MentionViewModel } from 'src/app/shared/components/mentions/mention-item/mention-item.component';
import { DrawerOptions, DrawerService, DrawerSize, DynamicComponentInfo } from 'src/app/shared/services/drawer.service';
import { Notifications } from './header/header-actions/header-actions.component';
import { phoneToPlainString, removeUsPhonePrefix } from 'src/utils';
import { Utils } from 'src/app/core/services/utils';
import { Lead } from 'src/app/modules/leads/models/lead.model';
import { LeadEditorComponent, LeadEditorDrawerFooterState } from 'src/app/modules/leads/components/lead-editor/lead-editor.component';
import { DrawerComponent } from 'src/app/shared/components/drawer/drawer.component';
import { firstValueFrom, Subscription } from 'rxjs';
import { GlobalSpinnerService } from 'src/app/shared/services/global-spinner.service';
import { DashboardV2Service } from 'src/app/modules/dashboardv2/services/dashboardv2.service';
import { ConversationService } from 'src/app/modules/conversations/services/conversation.service';
import { ChatMedium, Conversation, ConversationParticipant, MessageDirection, ParticipantType } from 'src/app/modules/conversations/models/conversation.model';
import { AgenticStatus } from 'src/app/modules/conversations/models/agentic-status.enum';
import { ConversationActivationRequest } from 'src/app/modules/conversations/models/conversation-activation-request.model';
import { applyTargetPersonContext } from 'src/app/modules/conversations/utils/conversation-context.utils';
import { GlobalConfig } from 'src/app/models/config/global-config.model';
import { ViewLeadDrawerComponent } from 'src/app/modules/leads/components/dialogs/view-lead-drawer/view-lead-drawer.component';
import * as _ from 'lodash';
import { ColorUtils } from 'src/app/shared/utils/color/utils';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import { UserActivityTrackerService } from 'src/app/services/user-activity-tracker.service';
import { DialerService } from 'src/app/modules/dialer/services/dialer.service';
import { DialerEventType } from 'src/app/modules/dialer/models/dialer-event.model';
import { CallControlPanelActionBarService } from 'src/app/modules/dialer/services/call-control-panel-action-bar.service';
import { ProfileService } from 'src/app/modules/profile/profile.service';
import { WizardUrl } from 'src/app/models/system-level.model';
import { AgentDrawerSubHeaderState, UpsertAgentComponent, UpsertAgentDrawerFooterState } from 'src/app/modules/agents/components/upsert-agent/upsert-agent.component';
import { AgentTabTypes } from 'src/app/modules/agents/models/agent-tab-model';
import { NewContactComponent } from 'src/app/modules/contacts/components/new-contact/new-contact.component';
import { BorrowerDetailsDrawerFooterState } from 'src/app/modules/borrower/components/borrower-details/borrower-details.component';
import { CONVERSATIONS_POPOUT_CHANNEL, CONVERSATIONS_POPOUT_WINDOW_NAME, ConversationsPopoutMessage } from 'src/app/modules/conversations/components/conversations-popout/conversations-popout.component';
import { PopoutManagerService } from 'src/app/shared/services/popout-manager.service';

@Component({
  selector: 'layout-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  standalone: false
})
export class LayoutAdminComponent implements OnInit, OnDestroy {

  @ViewChild('leadEditor')
  leadEditor: LeadEditorComponent;

  @ViewChild('newUpsertAgent')
  newUpsertAgent: UpsertAgentComponent;

  @ViewChild('editUpsertAgent')
  editUpsertAgent: UpsertAgentComponent;

  @ViewChild('newContactComponent')
  newContactComponent: NewContactComponent;

  @ViewChild('editLeadDrawer')
  editLeadDrawer: DrawerComponent;

  @ViewChild('editAgentDrawer')
  editAgentDrawer: DrawerComponent;

  @ViewChild('editContactDrawer')
  editContactDrawer: DrawerComponent;

  @ViewChild('mentionsDrawer')
  mentionsDrawer: DrawerComponent;

  user = {};
  userId: string = '';
  conversationsUserId: string = '';
  loanStatus: LoanStatus[] = [];
  avatarUrl: string;
  userProfile: UserProfile;

  unreadMentionCount: number = 0;
  mentionApplicationId: number | null = null;
  mentionLoanDocTask: LoanDocDashboardTask | null = null;

  notifications: Notifications = null;

  numberOfLoadedEmails: number = 0;

  mentionMessageScope: MentionMessageScope;

  messageId: number | null = null;

  insideLoanContext: boolean = false;

  taskMentionTrackingUrl: string;

  currentUserPhoneNumber: string;

  showLoanSummary: boolean;

  protected _hasUnreadConversations: boolean = false;

  private _allConversations: Conversation[] = [];

  get allConversations(): Conversation[] {
    return this._allConversations;
  }

  set allConversations(value: Conversation[]) {
    this._allConversations = value;
    this._hasUnreadConversations = this.computeHasUnreadConversations();
  }

  doInitializeConversationsWithSavedFilters: boolean = false;

  updatingConversation: boolean;

  refreshMentions: boolean;

  globalConfig: GlobalConfig;

  mentionTrackingGuid: string;

  agentIdToEdit: number | null = null;
  borrowerIdToEdit: number | null = null;
  niceInContactVisible: boolean = false;
  dialpadVisible: boolean = false;
  currentTab: string = 'ring-central';
  dialpadActiveTab: 'dialpad' | 'active-call' = 'dialpad';

  conversationActivationRequest: ConversationActivationRequest | null = null;

  usingPanelType: "classic" | "twilio" | "ringCentral" = "ringCentral";

  overrideCssUrl: string = null;
  brandLogoUrl: string = null;
  brandSmallLogoUrl: string = null;

  @HostBinding('class.company-2-theme')
  isCompany2: boolean = false;

  protected faviconUrl = '/assets/images/favicon_loda.ico';

  protected userIsImpersonating: boolean = true;

  private _mentionsDrawerOpened: boolean = false;
  private _notificationsDrawerOpened: boolean = false;
  private _conversationsDrawerOpened: boolean = false;
  private _newLeadDrawerOpened: boolean = false;
  private _editLeadDrawerOpened: boolean = false;
  private _editAgentDrawerOpened: boolean = false;
  private _editContactDrawerOpened: boolean = false;
  private _newAgentDrawerOpened: boolean = false;
  private _newContactDrawerOpened: boolean = false;
  private _newApplicationDrawerOpened: boolean = false;
  private _testAudioSettingsDrawerOpened: boolean = false;

  private _contextChangesForLoaninfoSubscription: Subscription;
  private _contextChangesSubscription: Subscription;
  private _contextSubscription: Subscription;
  private _subscriptionTologgedInUserChanges: Subscription;
  private _subscriptionToApplicationContextChanges: Subscription;
  private _conversationUpdatedSubscription: Subscription;
  private _conversationReminderSeenSubscription: Subscription;
  private _reconnectedSubscription: Subscription;
  private _borrowerChatRequestedSubscription: Subscription;
  private _agentChatRequestedSubscription: Subscription;
  private _internalChatRequestedSubscription: Subscription;
  private _routerEventsSubscription: Subscription;
  private _smsChatRequestedSubscription: Subscription;
  private _conversationDeletedSubscription: Subscription;
  private _openDrawersSubscription: Subscription;
  private _dialerEventsSubscription: Subscription;
  private _callControlPanelStateSubscription: Subscription;
  private _niceInContactVisibilitySubscription: Subscription;
  private _dialpadVisibilitySubscription: Subscription;

  private _popoutChannel: BroadcastChannel;

  private _currentConversationPageNumber = 1;

  private _conversationAutoRefreshInterval: any = null;

  mentionsDrawerOptions: DrawerOptions = {
    size: DrawerSize.Medium,
    containerWrapperId: 'drawer-wrapper',
  };

  alertsDrawerOptions: DrawerOptions = {
    size: DrawerSize.Medium,
    containerWrapperId: 'drawer-wrapper',
  };

  loanActivityDrawerOptions: DrawerOptions = {
    size: DrawerSize.Medium,
    containerWrapperId: 'drawer-wrapper',
  };

  taskEditorDrawerOptions: DrawerOptions = {
    size: DrawerSize.XXLarge,
    containerWrapperId: null,
  };

  conversationsDrawerOptions: DrawerOptions = {
    size: DrawerSize.Custom,
    containerWrapperId: null,
    width: 1400,
  };

  newLeadDrawerOptions: DrawerOptions = {
    size: DrawerSize.XXLarge,
    containerWrapperId: null,
  };

  newLeadFooterState: LeadEditorDrawerFooterState = {
    canSubmit: false,
    saving: false
  };

  editLeadDrawerOptions: DrawerOptions = {
    size: DrawerSize.XXXLarge,
    containerWrapperId: null,
  };

  editLeadFooterState: LeadEditorDrawerFooterState = {
    canSubmit: false,
    saving: false
  };

  private _editLeadViewComponent: ViewLeadDrawerComponent;

  newAgentDrawerOptions: DrawerOptions = {
    size: DrawerSize.XXLarge,
    containerWrapperId: null,
  };

  newAgentFooterState: UpsertAgentDrawerFooterState = {
    showFooter: false,
    saving: false,
    canSave: true,
    canSaveAndInvite: false,
    showSaveAndInvite: false,
    notesContent: '',
  };

  newAgentSubHeaderState: AgentDrawerSubHeaderState = {
    showTabs: false,
    activeTab: 'agentInfo',
    showOnlineAppLinks: false,
    wizardUrls: [],
  };

  editAgentDrawerOptions: DrawerOptions = {
    size: DrawerSize.XXXLarge,
    containerWrapperId: null,
  };

  editAgentTab: AgentTabTypes = 'agentInfo';

  editAgentFooterState: UpsertAgentDrawerFooterState = {
    showFooter: false,
    saving: false,
    canSave: true,
    canSaveAndInvite: false,
    showSaveAndInvite: false,
    notesContent: '',
  };

  editAgentSubHeaderState: AgentDrawerSubHeaderState = {
    showTabs: false,
    activeTab: 'agentInfo',
    showOnlineAppLinks: false,
    wizardUrls: [],
  };

  newContactDrawerOptions: DrawerOptions = {
    size: DrawerSize.XXLarge,
    containerWrapperId: null,
  };

  newContactFooterState: BorrowerDetailsDrawerFooterState = {
    canSubmit: false,
    saving: false,
  };

  editContactDrawerOptions: DrawerOptions = {
    size: DrawerSize.XXXLarge,
    containerWrapperId: null,
  };

  newApplicationDrawerOptions: DrawerOptions = {
    size: DrawerSize.XXLarge,
    containerWrapperId: null,
  };

  genericDrawerOptions: DrawerOptions = {
    size: DrawerSize.Medium,
    containerWrapperId: 'drawer-wrapper',
  };

  testAudioSettingsDrawerOptions: DrawerOptions = {
    size: DrawerSize.Large,
    containerWrapperId: null,
  };

  protected alertBorrowerId: number | undefined;
  protected alertAgentId: number | undefined;

  protected hasCallControlPanelActionBar: boolean = false;

  // Voice profile banner
  showVoiceProfileBanner: boolean = false;
  voiceProfileCampaignNames: string[] = [];

  private static readonly VOICE_PROFILE_BANNER_DISMISSED_KEY = 'voiceProfileBannerDismissed';

  constructor(
    private readonly _applicationContextService: ApplicationContextService,
    private readonly _signalRService: SignalRService,
    private readonly _loanUpdateCoordinator: LoanUpdateCoordinatorService,
    private readonly _firebaseService: FirebaseService,
    private readonly _taskService: TaskService,
    private readonly _drawerService: DrawerService,
    private readonly _router: Router,
    private readonly _environment: EnvironmentService,
    private readonly _conversationService: ConversationService,
    private readonly _localStorageService: LocalStorageService,
    private readonly _notifyService: NotificationService,
    private readonly _spinnerService: GlobalSpinnerService,
    private readonly _dashboardService: DashboardV2Service,
    private userActivityTracker: UserActivityTrackerService,
    private readonly _dialerService: DialerService,
    public readonly callControlPanelActionBarService: CallControlPanelActionBarService,
    private readonly _profileService: ProfileService,
    private readonly _popoutManager: PopoutManagerService,
    private readonly _ngZone: NgZone
  ) {
    this._openDrawersSubscription = this._drawerService.openDrawer$.subscribe(
      (info: { contactListType: ContactListType; recordId: number }) => {
        if (info.contactListType === ContactListType.Lead) {
          const lead = new Lead();
          lead.leadId = info.recordId;
          this.onEditRequestedForLeadId(lead);
        }
      }
    );

    this._dialerEventsSubscription = this._dialerService.events.subscribe(event => {
      if (event?.eventType === DialerEventType.callNumber ||
          event?.eventType === DialerEventType.callDialListRecord) {
        if (!this.dialpadVisible) {
          this.dialpadVisible = true;
          this._applicationContextService.dialpadVisibilityChanged(true);
          this.niceInContactVisible = false;
        }
      }
    });

    // Mirror external visibility broadcasts back onto our local boolean so
    // any caller (e.g. app-details-v2 opening the Loan Activity drawer) can
    // close the left call panels by simply broadcasting `false` through
    // ApplicationContextService — without this, our local boolean drifts
    // and the panel stays painted even though state says it's hidden.
    this._niceInContactVisibilitySubscription = this._applicationContextService.niceInContactVisibilityStateChanges
      .subscribe(isVisible => {
        if (this.niceInContactVisible !== !!isVisible) {
          this.niceInContactVisible = !!isVisible;
        }
      });

    this._dialpadVisibilitySubscription = this._applicationContextService.dialpadVisibilityStateChanges
      .subscribe(isVisible => {
        if (this.dialpadVisible !== !!isVisible) {
          this.dialpadVisible = !!isVisible;
        }
      });

    this._callControlPanelStateSubscription = this._applicationContextService.callControlPanelStatChanges.subscribe(context => {
      this.hasCallControlPanelActionBar = context.isCallControlPanelOpen;
      if (context.isCallControlPanelOpen) {
        this.dialpadActiveTab = 'active-call';
        if (!this.dialpadVisible) {
          this.dialpadVisible = true;
          this._applicationContextService.dialpadVisibilityChanged(true);
          this.niceInContactVisible = false;
        }
      } else {
        this.dialpadActiveTab = 'dialpad';
      }
    });

    this.faviconUrl = this._environment.faviconUrl;

    this._popoutChannel = new BroadcastChannel(CONVERSATIONS_POPOUT_CHANNEL);
    // zone.js doesn't patch BroadcastChannel, so messages arrive outside the Angular zone. Re-enter it so the
    // drawers these messages open or close render straight away.
    this._popoutChannel.onmessage = (event: MessageEvent<ConversationsPopoutMessage>) => this._ngZone.run(() => {
      if (event.data.type === 'popout-opened') {
        this._popoutManager.confirmAlive(CONVERSATIONS_POPOUT_WINDOW_NAME);
        // Popout just opened — close the drawer so we don't have two views
        this._drawerService.hide('conversationsDrawer', 10);
        this._conversationsDrawerOpened = false;
        document.body.classList.remove('body-no-scroll');
      } else if (event.data.type === 'popout-closed') {
        this._popoutManager.markClosed(CONVERSATIONS_POPOUT_WINDOW_NAME);
      } else if (event.data.type === 'edit-borrower' && event.data.payload) {
        this.onEditRequestedForContact(event.data.payload as RecentBorrower);
      } else if (event.data.type === 'edit-lead' && event.data.payload) {
        this.onEditRequestedForLeadId(event.data.payload as Lead);
      } else if (event.data.type === 'edit-agent' && event.data.payload) {
        this.onEditRequestedForAgent(event.data.payload as RecentAgent);
      } else if (event.data.type === 'open-application' && event.data.payload != null) {
        this.onOpenApplicationFromConversations(event.data.payload as number);
      }
    });

    // Discover whether a popout is already open (e.g. after a page refresh)
    this._popoutChannel.postMessage({ type: 'ping' } as ConversationsPopoutMessage);
  }

  ngOnInit() {

    const authData = this._localStorageService.authorizationData;
    this.userIsImpersonating = authData && !!authData.impersonatingAsAdmin;

    this.subscribeToEvents();

    this.getConversations();

    this.showLoanSummary = true;

    this.checkVoiceProfileNeeded();

    const body: HTMLBodyElement | null = document.querySelector('#loda-body');
    if (body) {
      body.classList.remove('tpo-background');
      body.classList.remove('pulse-processing-tpo-background');
    }
  }

  ngOnDestroy(): void {
    this._routerEventsSubscription?.unsubscribe();
    this._contextSubscription?.unsubscribe();
    this._contextChangesForLoaninfoSubscription?.unsubscribe();
    this._contextChangesSubscription?.unsubscribe();
    this._borrowerChatRequestedSubscription?.unsubscribe();
    this._agentChatRequestedSubscription?.unsubscribe();
    this._internalChatRequestedSubscription?.unsubscribe();
    this._smsChatRequestedSubscription?.unsubscribe();
    this._conversationDeletedSubscription?.unsubscribe();
    this._openDrawersSubscription?.unsubscribe();
    this._dialerEventsSubscription?.unsubscribe();
    this._callControlPanelStateSubscription?.unsubscribe();
    this._niceInContactVisibilitySubscription?.unsubscribe();
    this._dialpadVisibilitySubscription?.unsubscribe();
    this._conversationUpdatedSubscription?.unsubscribe();
    this._subscriptionTologgedInUserChanges?.unsubscribe();
    this._subscriptionToApplicationContextChanges?.unsubscribe();

    if (this._conversationAutoRefreshInterval) {
      clearInterval(this._conversationAutoRefreshInterval);
    }
    this._conversationUpdatedSubscription?.unsubscribe();
    this._conversationReminderSeenSubscription?.unsubscribe();
    this._reconnectedSubscription?.unsubscribe();

    this._popoutChannel?.close();
  }

  onAllConversationsMarkedAsRead = (conversations: Conversation[]) => {
    // Create a new array reference to trigger the setter and recalculate _hasUnreadConversations
    this.allConversations = [...conversations];
  }

  onConversationReadStatusChanged = (conversations: Conversation[]) => {
    // Create a new array reference to trigger the setter and recalculate _hasUnreadConversations
    this.allConversations = [...conversations];
  }

  onMentionClicked = (mention: MentionViewModel) => {
    this.mentionMessageScope = mention.messageScope;
    this.messageId = mention.messageId;
    this.refreshMentions = !mention.openDate; // reload mentions if unread

    // Every branch below opens a right-side drawer (Loan Activity, Task Editor,
    // or a Conversation chat). Match the mutual-exclusion behavior used when
    // Mentions/Alerts/Conversations open from the header: collapse the
    // left-rail call panels so loan content stays readable underneath.
    this.closeCallPanels();

    if (this.mentionMessageScope === MentionMessageScope.InternalMessage) {
      this.mentionApplicationId = mention.entityId;
      if (mention.trackingGuid) {
        this.mentionTrackingGuid = mention.trackingGuid;
      }
      this._drawerService.hide('taskEditorDrawer', 10);
      this._drawerService.show('loanActivityInternalMessageDrawer', 10);
    } else if (this.mentionMessageScope === MentionMessageScope.TaskNote) {
      this._taskService.getTaskDashboardViewById(mention.entityId).subscribe(
        (task) => {
          this.mentionLoanDocTask = task;
          if (mention.trackingGuid) {
            this.taskMentionTrackingUrl = `${this._environment.apiInfo.apiBaseUrl}mentions/pixel/${this.userId}/${mention.trackingGuid}`;
          }
          this._drawerService.hide('loanActivityInternalMessageDrawer', 10);
          this._drawerService.show('taskEditorDrawer', 10);
        },
        (error) => {
          this._notifyService.showError(error.error, 'Error!');
        }
      );
    } else if (this.mentionMessageScope === MentionMessageScope.BorrowerMessage) {
      this._conversationService.addBorrowerChat(
        mention.applicationId,
        mention.borrowerId,
        { senderDisplayName: "" },
        true,
        false,
        mention.conversationId
      );
    } else if (this.mentionMessageScope === MentionMessageScope.AgentMessage) {
      this._conversationService.addAgentChat(
        mention.applicationId,
        mention.agentId,
        { senderDisplayName: "" },
        true,
        false,
        mention.conversationId
      );
    }
  };

  onAlertsCreated = (alerts: AlertModel[]) => {
    alerts.forEach((a) => {
      const bucketThatAlertNeedsToGoTo = this.notifications?.alertBuckets?.find(
        (b) => b.type == a.alertType
      );
      if (bucketThatAlertNeedsToGoTo) {
        bucketThatAlertNeedsToGoTo.alerts.splice(0, 0, a);
      }
      const updatedNotifications = { ...this.notifications };
      this.notifications = updatedNotifications as Notifications;
    });
  };

  onNotificationsToggled = (notifications: Notifications) => {
    this.notifications = notifications;
    this.closeNotificationDrawers('alerts');
    if (notifications && !this._notificationsDrawerOpened) {
      this.closeCallPanels();
      this._drawerService.show('alertsDrawer', 10);
      this._notificationsDrawerOpened = true;
    } else {
      this._drawerService.hide('alertsDrawer', 10);
    }
  };

  onMentionsStreamToggled = (open: boolean) => {
    this.closeNotificationDrawers('mentions');
    if (open && !this._mentionsDrawerOpened) {
      this.closeCallPanels();
      this._drawerService.show('mentionsDrawer', 10);
      this._mentionsDrawerOpened = true;
    } else {
      this._drawerService.hide('mentionsDrawer', 10);
    }
  };

  onDialpadToggled = () => {
    this.dialpadVisible = !this.dialpadVisible;
    this._applicationContextService.dialpadVisibilityChanged(this.dialpadVisible);
    if (this.dialpadVisible) {
      this.closeCallPanels('dialpad');
      this.closeNotificationDrawers();
    }
  };

  onNiceInContactClosed = () => {
    this.niceInContactVisible = false;
    this._applicationContextService.niceInContactVisibilityChanged(false);
  };

  protected onStopImpersonatingClicked = () => {
    this.userIsImpersonating = false;
    this._router.navigate(['end-impersonation-mode'], {
      queryParams: {},
    });
  };

  onRecordVoiceProfileClicked = () => {
    this._router.navigate(['/admin/profile'], { fragment: 'voice-profile' });
    this.onDismissVoiceProfileBanner();
  };

  onDismissVoiceProfileBanner = () => {
    this.showVoiceProfileBanner = false;
    try {
      sessionStorage.setItem(LayoutAdminComponent.VOICE_PROFILE_BANNER_DISMISSED_KEY, 'true');
    } catch {
      // sessionStorage may not be available in some environments
    }
  };

  private checkVoiceProfileNeeded(): void {
    // Don't show the banner if already dismissed this session
    try {
      if (sessionStorage.getItem(LayoutAdminComponent.VOICE_PROFILE_BANNER_DISMISSED_KEY) === 'true') {
        return;
      }
    } catch {
      // sessionStorage may not be available
    }

    this._profileService.checkNeedsVoiceProfileRecording().subscribe({
      next: (response) => {
        if (response?.needsRecording) {
          this.voiceProfileCampaignNames = response.campaignNames || [];
          this.showVoiceProfileBanner = true;
        }
      },
      error: () => {
        // Silently fail - banner is non-critical
      }
    });
  }

  onNiceInContactToggled= (activeTab: string) => {
    if (this.currentTab == activeTab) {
      this.niceInContactVisible = !this.niceInContactVisible;
    } else {
      this.currentTab = activeTab;
      if (!this.niceInContactVisible) {
        this.niceInContactVisible = !this.niceInContactVisible;
      }
    }
    this._applicationContextService.niceInContactVisibilityChanged(
      this.niceInContactVisible
    );
    if (this.niceInContactVisible) {
      this.closeCallPanels('niceInContact');
      this.closeNotificationDrawers();
    }
  };

  onConversationsToggled = (open: boolean) => {
    // If the popout window is alive, bring it to the front
    if (this._popoutManager.isAlive(CONVERSATIONS_POPOUT_WINDOW_NAME)) {
      if (!this._popoutManager.focus(CONVERSATIONS_POPOUT_WINDOW_NAME)) {
        // Window reference lost (e.g. after a page refresh) — fall back to BroadcastChannel
        this._popoutChannel.postMessage({ type: 'focus-requested' } as ConversationsPopoutMessage);
      }
      return;
    }

    open = true;
    this.closeNotificationDrawers('conversations');
    if (open && !this._conversationsDrawerOpened) {
      this.closeCallPanels();
      this._openConversationDrawer();
    } else {
      this._drawerService.hide('conversationsDrawer', 10);
      this._conversationsDrawerOpened = false;
      document.body.classList.remove('body-no-scroll');
    }
  };

  onPopoutConversationsClicked = () => {
    // If a popout is already open, bring it to the front
    if (this._popoutManager.isAlive(CONVERSATIONS_POPOUT_WINDOW_NAME)) {
      if (!this._popoutManager.focus(CONVERSATIONS_POPOUT_WINDOW_NAME)) {
        this._popoutChannel.postMessage({ type: 'focus-requested' } as ConversationsPopoutMessage);
      }
      return;
    }

    this._popoutManager.open({
      url: '/conversations-popout',
      windowName: CONVERSATIONS_POPOUT_WINDOW_NAME,
    });

    // Close the drawer — the BroadcastChannel 'popout-opened' message will also
    // handle this, but closing eagerly provides a smoother experience.
    this._drawerService.hide('conversationsDrawer', 10);
    this._conversationsDrawerOpened = false;
    document.body.classList.remove('body-no-scroll');
  };

  /**
   * Closes left-rail call panels. Pass the panel that should stay open
   * (e.g. `'niceInContact'` when opening NiceInContact) to keep it alive
   * while collapsing the other; pass nothing to collapse both.
   */
  private closeCallPanels = (except?: 'niceInContact' | 'dialpad'): void => {
    if (except !== 'niceInContact' && this.niceInContactVisible) {
      this.niceInContactVisible = false;
      this._applicationContextService.niceInContactVisibilityChanged(false);
    }
    if (except !== 'dialpad' && this.dialpadVisible) {
      this.dialpadVisible = false;
      this._applicationContextService.dialpadVisibilityChanged(false);
    }
  };

  /**
   * Closes right-side notification drawers. Pass the drawer that should
   * stay open (e.g. `'alerts'` when opening Alerts) to keep it alive while
   * collapsing the others; pass nothing to collapse all three.
   *
   * Also hides the two Loan Activity drawers — `loanActivityInternalMessageDrawer`
   * (declared on this layout, opened by clicking an InternalMessage mention)
   * and `loanActivityDrawer` (declared in app-details-v2, opened from the loan
   * summary top bar). They compete for the same right-side slot, so the
   * mutual-exclusion that already covers alerts/mentions/conversations should
   * cover them too. `DrawerService.hide` is a no-op when the drawer isn't
   * open, so unconditional calls are safe.
   */
  private closeNotificationDrawers = (except?: 'alerts' | 'mentions' | 'conversations'): void => {
    if (except !== 'alerts' && this._notificationsDrawerOpened) {
      this._drawerService.hide('alertsDrawer', 10);
    }
    if (except !== 'mentions' && this._mentionsDrawerOpened) {
      this._drawerService.hide('mentionsDrawer', 10);
    }
    if (except !== 'conversations' && this._conversationsDrawerOpened) {
      this._drawerService.hide('conversationsDrawer', 10);
      this._conversationsDrawerOpened = false;
      document.body.classList.remove('body-no-scroll');
    }
    this._drawerService.hide('loanActivityInternalMessageDrawer', 10);
    this._drawerService.hide('loanActivityDrawer', 10);
  };

  onNewLeadToggled = () => {
    if (this._newContactDrawerOpened) {
      this._drawerService.hide('newContactDrawer', 10);
      this._newContactDrawerOpened = false;
    }
    if (this._newAgentDrawerOpened) {
      this._drawerService.hide('newAgentDrawer', 10);
      this._newAgentDrawerOpened = false;
    }
    if (this._newApplicationDrawerOpened) {
      this._drawerService.hide('newApplicationDrawer', 10);
      this._newApplicationDrawerOpened = false;
    }
    this.newLeadFooterState = {
      canSubmit: false,
      saving: false
    };
    this._newLeadDrawerOpened = true;
    this._drawerService.show('newLeadDrawer', 10);
  };

  onNewAgentToggled = () => {
    if (this._newLeadDrawerOpened) {
      this._drawerService.hide('newLeadDrawer', 10);
      this._newLeadDrawerOpened = false;
    }
    if (this._newContactDrawerOpened) {
      this._drawerService.hide('newContactDrawer', 10);
      this._newContactDrawerOpened = false;
    }
    if (this._newApplicationDrawerOpened) {
      this._drawerService.hide('newApplicationDrawer', 10);
      this._newApplicationDrawerOpened = false;
    }
    this.newAgentFooterState = {
      showFooter: false,
      saving: false,
      canSave: true,
      canSaveAndInvite: false,
      showSaveAndInvite: false,
      notesContent: '',
    };
    this.newAgentSubHeaderState = {
      showTabs: false,
      activeTab: 'agentInfo',
      showOnlineAppLinks: false,
      wizardUrls: [],
    };
    this._newAgentDrawerOpened = true;
    this._drawerService.show('newAgentDrawer', 10);
  };

  onNewContactToggled = () => {
    if (this._newLeadDrawerOpened) {
      this._drawerService.hide('newLeadDrawer', 10);
      this._newLeadDrawerOpened = false;
    }
    if (this._newAgentDrawerOpened) {
      this._drawerService.hide('newAgentDrawer', 10);
      this._newAgentDrawerOpened = false;
    }
    if (this._newApplicationDrawerOpened) {
      this._drawerService.hide('newApplicationDrawer', 10);
      this._newApplicationDrawerOpened = false;
    }
    this.newContactFooterState = {
      canSubmit: false,
      saving: false,
    };
    this._newContactDrawerOpened = true;
    this._drawerService.show('newContactDrawer', 10);
  };

  onNewApplicationToggled = () => {
    if (this._newLeadDrawerOpened) {
      this._drawerService.hide('newLeadDrawer', 10);
      this._newLeadDrawerOpened = false;
    }
    if (this._newAgentDrawerOpened) {
      this._drawerService.hide('newAgentDrawer', 10);
      this._newAgentDrawerOpened = false;
    }
    if (this._newContactDrawerOpened) {
      this._drawerService.hide('newContactDrawer', 10);
      this._newContactDrawerOpened = false;
    }
    this._newApplicationDrawerOpened = true;
    this._drawerService.show('newApplicationDrawer', 10);
  };

  onTestAudioSettingsToggled = () => {
    if (!this._testAudioSettingsDrawerOpened) {
      this._drawerService.show('testAudioSettingsDrawer', 10);
      this._testAudioSettingsDrawerOpened = true;
    } else {
      this._drawerService.hide('testAudioSettingsDrawer', 10);
    }
  };

  onTestAudioSettingsDrawerClosed = () => {
    this._testAudioSettingsDrawerOpened = false;
  };

  private computeHasUnreadConversations(): boolean {
    const unread = this._allConversations.filter(
      (c) => c.isUnread == true && !c.isHidden
    );

    // If no unread top-level conversations, check nested conversations
    if (unread.length === 0) {
      for (const conversation of this._allConversations) {
        if (conversation.conversations && conversation.conversations.length > 0) {
          const hasUnreadNested = conversation.conversations.some(
            (nestedConvo) => nestedConvo.isUnread == true && !nestedConvo.isHidden
          );
          if (hasUnreadNested) {
            return true;
          }
        }
      }
      return false;
    }

    return unread.length > 0;
  }

  onNotificationsDrawerClosed = () => {
    this._notificationsDrawerOpened = false;
  };

  onMentionsDrawerClosed = () => {
    this._mentionsDrawerOpened = false;
  };

  onMentionDetailsDrawerClosed = () => { };

  onConversationsDrawerClosed = () => {
    this.alertBorrowerId = undefined;

    this.alertAgentId = undefined;

    // Make sure to set all conversations to inactive, messes with notifs and displaying new messages if we don't
    this._allConversations = this._allConversations.map(x => ({ ...x, isActive: false }));
    this._conversationsDrawerOpened = false;
    document.body.classList.remove('body-no-scroll');
    //load the current user conversations if impersonate user conversation are loaded.
    if (this.conversationsUserId !== this.userProfile.userCompanyGuid) {
      this.onImpersonatedUserChanged(this.userId);
    }
  };

  onNewLeadDrawerClosed = () => {
    this._newLeadDrawerOpened = false;
  };

  onNewLeadDrawerClose = (lead?: Lead) => {
    this._drawerService.hide('newLeadDrawer', 10);
    this._newLeadDrawerOpened = false;
    if (lead?.leadId > 0) {
      this.onEditRequestedForLead(lead);
    }
  };

  onNewLeadCancelled = () => {
    this._drawerService.hide('newLeadDrawer', 10);
  };

  onNewLeadFooterStateChanged = (state: LeadEditorDrawerFooterState) => {
    this.newLeadFooterState = state;
  };

  saveNewLeadFromFooter = () => {
    this.leadEditor?.save();
  };

  onEditLeadDrawerClosed = () => {
    this._editLeadDrawerOpened = false;
    this._editLeadViewComponent = null;
    this._dashboardService.leadEditingEnded();
  };

  onEditLeadDrawerOpened = () => {
    this._dashboardService.leadOpenedForEdit();
  };

  onEditLeadComponentLoaded = (componentInstance: ViewLeadDrawerComponent) => {
    this._editLeadViewComponent = componentInstance;
    this.editLeadFooterState = {
      canSubmit: false,
      saving: false
    };
    componentInstance.footerStateChanged.subscribe((state: LeadEditorDrawerFooterState) => {
      this.editLeadFooterState = state;
    });
  };

  closeEditLeadDrawerFromFooter = () => {
    this._drawerService.hide('editLeadDrawer', 100);
  };

  saveEditLeadFromFooter = () => {
    this._editLeadViewComponent?.saveFromFooter();
  };

  saveActivityNoteFromFooter = () => {
    this._editLeadViewComponent?.saveActivityNoteFromFooter();
  };

  cancelActivityNoteFromFooter = () => {
    this._editLeadViewComponent?.cancelActivityNoteFromFooter();
    this.closeEditLeadDrawerFromFooter();
  };

  onEditRequestedForLead = (lead: Lead) => {
    const dynamicComponentInfo = new DynamicComponentInfo();
    dynamicComponentInfo.componentType = ViewLeadDrawerComponent;
    dynamicComponentInfo.parameters.set('lead', lead);

    this._drawerService.show(
      'editLeadDrawer',
      10,
      'Editing Lead - ' + Utils.getPersonsDisplayName(lead),
      dynamicComponentInfo
    );
    this._spinnerService.hide();
  };

  onEditRequestedForLeadId = (lead: RecentLead) => {
    const dynamicComponentInfo = new DynamicComponentInfo();
    dynamicComponentInfo.componentType = ViewLeadDrawerComponent;
    dynamicComponentInfo.parameters.set('leadId', lead.leadId);

    this._drawerService.show(
      'editLeadDrawer',
      10,
      'Editing Lead',
      dynamicComponentInfo
    );
    this._spinnerService.hide();
  };

  onNewAgentDrawerClosed = () => {
    this._newAgentDrawerOpened = false;
    this.newAgentFooterState = {
      showFooter: false,
      saving: false,
      canSave: true,
      canSaveAndInvite: false,
      showSaveAndInvite: false,
      notesContent: '',
    };
    this.newAgentSubHeaderState = {
      showTabs: false,
      activeTab: 'agentInfo',
      showOnlineAppLinks: false,
      wizardUrls: [],
    };
  };

  onNewAgentDrawerClose = (agent?: RecentAgent) => {
    this._drawerService.hide('newAgentDrawer', 10);
    this._newAgentDrawerOpened = false;
    if (agent?.agentId > 0) {
      this.onEditRequestedForAgent(agent);
    }
  };

  closeNewAgentDrawerFromFooter = () => {
    this.newUpsertAgent?.closeFromFooter();
  };

  saveNewAgentFromFooter = () => {
    this.newUpsertAgent?.saveFromFooter();
  };

  saveAndCloseNewAgentFromFooter = () => {
    this.newUpsertAgent?.saveAndCloseFromFooter();
  };

  saveAndInviteNewAgentFromFooter = () => {
    this.newUpsertAgent?.saveAndInviteFromFooter();
  };

  onNewAgentFooterStateChanged = (state: UpsertAgentDrawerFooterState) => {
    this.newAgentFooterState = state;
  };

  onNewAgentSubHeaderStateChanged = (state: AgentDrawerSubHeaderState) => {
    this.newAgentSubHeaderState = state;
  };

  selectNewAgentDrawerTab = (tab: AgentTabTypes) => {
    this.newUpsertAgent?.selectTab(tab);
  };

  copyNewAgentWizardUrl = (wizardUrl: WizardUrl) => {
    this.newUpsertAgent?.copyLink(wizardUrl);
  };

  updateNewAgentNotesDraft = (content: string) => {
    this.newUpsertAgent?.updateNotesDraft(content);
  };

  onEditAgentDrawerClosed = () => {
    this._editAgentDrawerOpened = false;
    this.editAgentFooterState = {
      showFooter: false,
      saving: false,
      canSave: true,
      canSaveAndInvite: false,
      showSaveAndInvite: false,
      notesContent: '',
    };
    this.editAgentSubHeaderState = {
      showTabs: false,
      activeTab: 'agentInfo',
      showOnlineAppLinks: false,
      wizardUrls: [],
    };
  };

  onEditAgentDrawerClose = () => {
    this._drawerService.hide('editAgentDrawer', 10);
    this._editAgentDrawerOpened = false;
  };

  onEditRequestedForAgent = (agent: RecentAgent) => {
    this.agentIdToEdit = agent.agentId;
    this.editAgentTab = 'agentInfo';
    this.editAgentFooterState = {
      showFooter: false,
      saving: false,
      canSave: true,
      canSaveAndInvite: false,
      showSaveAndInvite: false,
      notesContent: '',
    };
    this.editAgentSubHeaderState = {
      showTabs: false,
      activeTab: 'agentInfo',
      showOnlineAppLinks: false,
      wizardUrls: [],
    };
    this.editAgentDrawer.title =
      'Editing Agent - ' + Utils.getPersonsDisplayName(agent);

    setTimeout(() => {
      this._drawerService.show('editAgentDrawer', 10);
    }, 100);
  };

  closeEditAgentDrawerFromFooter = () => {
    this.editUpsertAgent?.closeFromFooter();
  };

  saveEditAgentFromFooter = () => {
    this.editUpsertAgent?.saveFromFooter();
  };

  saveAndCloseEditAgentFromFooter = () => {
    this.editUpsertAgent?.saveAndCloseFromFooter();
  };

  onEditAgentFooterStateChanged = (state: UpsertAgentDrawerFooterState) => {
    this.editAgentFooterState = state;
  };

  onEditAgentSubHeaderStateChanged = (state: AgentDrawerSubHeaderState) => {
    this.editAgentSubHeaderState = state;
  };

  selectEditAgentDrawerTab = (tab: AgentTabTypes) => {
    this.editUpsertAgent?.selectTab(tab);
  };

  copyEditAgentWizardUrl = (wizardUrl: WizardUrl) => {
    this.editUpsertAgent?.copyLink(wizardUrl);
  };

  updateEditAgentNotesDraft = (content: string) => {
    this.editUpsertAgent?.updateNotesDraft(content);
  };

  onNewContactDrawerClosed = () => {
    this._newContactDrawerOpened = false;
    this.newContactFooterState = {
      canSubmit: false,
      saving: false,
    };
  };

  onNewContactCreated = (borr?: RecentBorrower) => {
    this._drawerService.hide('newContactDrawer', 10);
    this._newContactDrawerOpened = false;
    if (borr?.borrowerId > 0) {
      this.onEditRequestedForContact(borr);
    }
  };

  onEditContactDrawerClosed = () => {
    this._editContactDrawerOpened = false;
  };

  onEditContactDrawerClose = () => {
    this._drawerService.hide('editContactDrawer', 10);
    this._editContactDrawerOpened = false;
  };

  onNewContactDrawerClose = () => {
    this._drawerService.hide('newContactDrawer', 10);
    this._newContactDrawerOpened = false;
  };

  closeNewContactDrawerFromFooter = () => {
    this.newContactComponent?.closeFromFooter();
  };

  saveNewContactFromFooter = () => {
    this.newContactComponent?.saveFromFooter();
  };

  onNewContactFooterStateChanged = (state: BorrowerDetailsDrawerFooterState) => {
    this.newContactFooterState = state;
  };

  onEditRequestedForContact = (borr: RecentBorrower) => {
    this.borrowerIdToEdit = borr.borrowerId;
    this.editContactDrawer.title =
      'Editing Contact - ' + Utils.getPersonsDisplayName(borr);

    setTimeout(() => {
      this._drawerService.show('editContactDrawer', 10);
    }, 100);
  };

  onImpersonatedUserChanged = (userId: string) => {
    //reload chats
    this.getConversations(userId);
  };

  // Opening a linked application always targets the main window (whether the
  // request comes from the in-layout conversations drawer or is relayed from the
  // conversations popout over the BroadcastChannel), so it never routes inside
  // the locked popout window.
  onOpenApplicationFromConversations = (applicationId: number) => {
    if (applicationId == null) {
      return;
    }
    this._router.navigate([`admin/app-details/${applicationId}`]);
  };

  onNewApplicationDrawerClosed = () => {
    this._newApplicationDrawerOpened = false;
  };

  onNewApplicationDrawerClose = () => {
    this._drawerService.hide('newApplicationDrawer', 10);
    this._newApplicationDrawerOpened = false;
  };

  onEmailsLoaded = (_numberOfRecordsLoaded: number) => {
    // this.numberOfLoadedMentions += numberOfRecordsLoaded;
  };

  notificationDetails = (alert: AlertModel) => {
    // TODO: There is no agentId on the alert model - how to identify the agent conversation then?
    // if (alert.agentId) {
    //   this.alertAgentId = alert.agentId;
    // }
    if (alert && alert.alertType == 'BorrowerMessageAlert') {
      //open the message conversation in the chats panel
      this.alertBorrowerId = alert.borrowerId;
      document.body.classList.add('body-no-scroll');
      this._drawerService.show('conversationsDrawer', 10);
      this._conversationsDrawerOpened = true;
      setTimeout(() => this.alertMessage(alert), 500);
    } else if (alert && alert.applicationId && alert.taskId) {
      //Open the task in the side panel
      this._taskService.getTaskDashboardViewById(alert.taskId).subscribe(
        (task) => {
          this.mentionLoanDocTask = task;
          this.mentionMessageScope = MentionMessageScope.TaskNote;
          this._drawerService.show(
            'taskEditorDrawer',
            10,
            undefined,
            undefined,
            {
              size: DrawerSize.XXLarge,
              containerWrapperId: null,
            }
          );
        },
        (error) => {
          this._notifyService.showError(error.error, 'Error!');
        }
      );
    } else if (alert && alert.applicationId && alert.borrowerId) {
      this._router.navigate([`admin/app-details/${alert.applicationId}`]);
    } else if (alert && alert.leadId) {
      this.viewViewLeadModal(alert.leadId);
    }
  };

  alertMessage = (_alert) => {
    // let index = this.conversationList.allChats.findIndex(chat => chat.applicationId == alert.applicationId);
    // this.conversationList.allChats[index].isChatWindowOpened = true;
    // this.conversationList.loadChatHistory(this.conversationList.allChats[index]);
  };

  viewViewLeadModal = (leadId: number) => {
    if (!leadId) {
      console.error('invalid leadId.');
      return;
    }
    this._drawerService.openDrawer({
      contactListType: ContactListType.Lead,
      recordId: leadId,
    });
  };

  private onSmsChatRequested = async (smsChat: SmsChatRequestedModel) => {
    const internalPhone = smsChat.betweenPhone || this.currentUserPhoneNumber;
    // Only an explicit request (e.g. an SMS bubble click) may change the selected conversation; incoming messages
    // come through here too and must not take the selection away from the user.
    const activationToken = smsChat.openDrawer ? this._conversationService.nextActivationToken() : null;
    // False for incoming messages, and for a click that a newer click has superseded while this one awaited the API.
    const isLatestRequest = () => this.isLatestActivationToken(activationToken);

    let convo: Conversation;

    if (smsChat.smsMessage?.conversationId) {

      // Find the parent group for the incoming conversation
      const parentGroup = this.allConversations.find(group =>
        group.conversations?.some(c => c.conversationId === smsChat.smsMessage?.conversationId)
      );

      if (parentGroup) {
        // Now find the actual conversation under the parent
        convo = parentGroup.conversations.find(c => c.conversationId === smsChat.smsMessage?.conversationId);
      }

      if (convo) {
        this.updateConversationStateAfterNewMessage(convo, smsChat);

        // Replace parent with convo, keep and sort children
        convo.conversations = _.orderBy(parentGroup.conversations, ['mostRecentMessageDate'], ['desc']);
        const parentIdx = this.allConversations.indexOf(parentGroup);
        if (parentIdx > -1) {
          this.allConversations.splice(parentIdx, 1); // Remove the old conversation at parentIdx
          this.allConversations.unshift(convo); // Add the new conversation to the top
        }

        if (!this._conversationsDrawerOpened) {
          convo.isActive = true;
          this.allConversations
            .filter((x) => x.conversationId !== convo.conversationId)
            .forEach((x) => (x.isActive = false));

          if (smsChat.openDrawer) {
            this._openConversationDrawer();
          }
        }

        this.requestConversationActivation(activationToken, convo.conversationId);
        this._conversationService.addSmsMessageToChat(smsChat.smsMessage);

        this.allConversations = [...this.allConversations];
        return;
      }
    }

    const convos = this.allConversations.filter((chat) => {
      const internalParticipants = [];
      const externalParticipants = chat.participants.filter(
        (p) => p.participantType === ParticipantType.External
      );

      if (chat.conversations && chat.conversations.length > 0) {
        chat.conversations.forEach((convo) => {
          const internalParticipant = convo.participants.find((p) => p.participantType === ParticipantType.Internal);
          if (internalParticipant) {
            internalParticipants.push(
              convo.participants.find(
                (p) => p.participantType === ParticipantType.Internal
              )
            );
          }
        });
      }

      const internalParticipant = internalParticipants.find(
        (p) =>
          phoneToPlainString(removeUsPhonePrefix(p.phoneNumber)) ===
          phoneToPlainString(removeUsPhonePrefix(internalPhone))
      );

      const externalParticipant = externalParticipants.find(
        (p) =>
          phoneToPlainString(removeUsPhonePrefix(p.phoneNumber)) ===
          phoneToPlainString(removeUsPhonePrefix(smsChat.userPhone))
      );
      if (!externalParticipant || !internalParticipant) {
        return false;
      }

      return (
        internalParticipant &&
        externalParticipant &&
        (phoneToPlainString(
          removeUsPhonePrefix(externalParticipant.phoneNumber)
        ) === phoneToPlainString(removeUsPhonePrefix(smsChat.userPhone)) ||
          !smsChat.userName)
      ); // internal bubble || external message
    });

    if (convos?.length == 1) {
      convo = convos[0];

      await this.updateConversationForId(convo, smsChat);
      // The update above may have replaced the row with the API's copy.
      convo = this.allConversations.find(c => c.conversationId === convo.conversationId) ?? convo;
      if (convo.isHidden) {
        this._updateConversationHiddenStatus(convo, false);
      }
      convo.mostRecentMessageDate = new Date();
      convo.mostRecentMessagePreview = smsChat.smsMessage?.body || ' ';
      if (convo.isActive) {
        if (smsChat.smsMessage) {
          smsChat.smsMessage.conversationId = convo.conversationId;
          this._conversationService.addSmsMessageToChat(smsChat.smsMessage);
        }
      } else if (smsChat.smsMessage?.direction === MessageDirection.Inbound) {
        // Only a message from the other person makes the row unread; opening a chat from an SMS link does not.
        convo.isUnread = true;
      }

      if (!convo.isActive) {
        convo.isActive = smsChat.openDrawer && isLatestRequest();
      }
      if (convo.isActive) {
        this.allConversations
          .filter((x) => x.conversationId !== convo.conversationId)
          .forEach((x) => (x.isActive = false));
      }
      const index = this.allConversations.indexOf(convo);
      if (index > -1) {
        this.allConversations.splice(index, 1);
        this.allConversations.unshift(convo);
      }
      if (isLatestRequest()) {
        applyTargetPersonContext(convo, smsChat.conversationTargetPersonContext);
      }
      this.requestConversationActivation(activationToken, convo.conversationId);
    } else if (convos.length > 1) {
      for (const convo of convos) {
        await this.updateConversationForId(convo, smsChat);

        if (convo.isHidden) {
          this._updateConversationHiddenStatus(convo, false);
        }

        convo.isUnread = true;
        const index = this.allConversations.indexOf(convo);
        if (index > -1) {
          this.allConversations.splice(index, 1);
        }
      }

      this.allConversations.forEach((x) => (x.isActive = false));
      this.allConversations.unshift(...convos);

      Swal.fire({
        title: 'Reminder',
        text: `${smsChat.userName || smsChat.userPhone} is a participant in ${convos.length
          } conversations. Please pick the one you'd like to proceed with from the conversations list.`,
        icon: 'warning',
        confirmButtonText: 'OK',
      });
    } else {
      //todo: call api to register conversation
      const newConversation = new Conversation();
      newConversation.assignedTo = this.userId;
      const externalParticipant = new ConversationParticipant();
      const internalParticipant = new ConversationParticipant();

      externalParticipant.participantType = ParticipantType.External;
      internalParticipant.participantType = ParticipantType.Internal;
      externalParticipant.phoneNumber = smsChat.userPhone.startsWith('+1')
        ? smsChat.userPhone
        : `+1${smsChat.userPhone}`;
      internalParticipant.phoneNumber = internalPhone.startsWith('+1')
        ? internalPhone
        : `+1${internalPhone}`;
      newConversation.chatMedium = ChatMedium.Sms;
      // A conversation the user starts from an SMS link has nothing unread; one created for an incoming text does.
      newConversation.isUnread = smsChat.smsMessage?.direction === MessageDirection.Inbound;
      newConversation.mostRecentIncomingMessageDate = new Date();
      newConversation.lastReadDate =
        newConversation.mostRecentIncomingMessageDate;
      newConversation.externalName = smsChat.userName;
      newConversation.conversationId = smsChat.smsMessage?.conversationId;
      newConversation.mostRecentMessagePreview = ' ';
      newConversation.participants = [];
      newConversation.contactAlias = smsChat.userName
        ? smsChat.userName
          .match(/(\b\S)?/g)
          .join('')
          .match(/(^\S|\S$)?/g)
          .join('')
          .toUpperCase()
        : 'N/A';

      newConversation.participants.push(externalParticipant);
      newConversation.participants.push(internalParticipant);

      newConversation.agentId = smsChat.conversationTargetPersonContext?.agentId || null;
      newConversation.applicationId = smsChat.conversationTargetPersonContext?.applicationId || null;
      newConversation.borrowerId = smsChat.conversationTargetPersonContext?.borrowerId || null;
      newConversation.leadId = smsChat.conversationTargetPersonContext?.leadId || null;

      // Call API to create conversation in DB
      this._spinnerService.show();
      this._conversationService
        .saveConversation(newConversation)
        .subscribe({
          next: async (result) => {
            // The API returns the existing conversation when one with these participants already exists. It may
            // already be in the list (possibly grouped under another row), or be past the first page we loaded.
            const existingRow = this.findConversationListItem(result.conversationId);
            if (!existingRow) {
              result.conversations = [result];
              this.allConversations.unshift(result);
            }
            const target = existingRow
              ? (existingRow.conversationId === result.conversationId
                ? existingRow
                : existingRow.conversations.find(c => c.conversationId === result.conversationId))
              : result;
            await this.updateConversationForId(target, smsChat);

            if (isLatestRequest()) {
              const row = this.findConversationListItem(result.conversationId);
              if (row) {
                if (row.isHidden) {
                  // The dedup can return an archived conversation; archived rows are kept out of the list.
                  this._updateConversationHiddenStatus(row, false);
                }
                applyTargetPersonContext(row, smsChat.conversationTargetPersonContext);
                row.isActive = true;
                this.allConversations
                  .filter((x) => x !== row)
                  .forEach((x) => (x.isActive = false));
              }
              this.requestConversationActivation(activationToken, result.conversationId);
            }
            this.allConversations = [...this.allConversations];

            // Open the drawer only now; opening it before the conversation is known would show the previous
            // recipient's conversation, ready to be typed into.
            if (!this._conversationsDrawerOpened && smsChat.openDrawer && isLatestRequest()) {
              this._openConversationDrawer();
            }
          },
          error: (err) => {
            this._notifyService.showError(
              err ? (err.data ? err.data.message : '') : '',
              'Error'
            );
          },
        })
        .add(() => this._spinnerService.hide());
      return;
    }

    if (!this._conversationsDrawerOpened && smsChat.openDrawer && isLatestRequest()) {
      this._openConversationDrawer();
    }

    this.allConversations = [...this.allConversations];
  };

  private updateConversationStateAfterNewMessage = (
    convo: Conversation,
    smsChat: SmsChatRequestedModel
  ) => {
    // If the message coming in is older than the most recent message in the conversation, don't update the conversation
    // if (
    //   convo.mostRecentMessageDate &&
    //   smsChat.smsMessage?.dateUpdated &&
    //   convo.mostRecentMessageDate >= new Date(smsChat.smsMessage?.dateUpdated)
    // ) {
    //   return;
    // }
    convo.mostRecentMessagePreview = smsChat.smsMessage?.body;
    convo.mostRecentMessageDate =
      typeof smsChat.smsMessage?.dateInserted == 'string'
        ? new Date(smsChat.smsMessage?.dateInserted)
        : smsChat.smsMessage?.dateInserted;
    convo.mostRecentIncomingMessageDate = convo.mostRecentMessageDate;
    convo.lastReadDate = convo.mostRecentMessageDate;

    const isInbound = smsChat.smsMessage?.direction == MessageDirection.Inbound
      && convo.conversationId == smsChat.smsMessage?.conversationId;

    if (isInbound && convo.isAutoPilotEnabled) {
      convo.isUnread = false;
      convo.agenticStatus = AgenticStatus.Active;
    } else {
      convo.isUnread = isInbound;
    }
  };

  private initializeFromContext = (context: ApplicationContext) => {
    this.avatarUrl = context.currentlyLoggedInUserProfile.userProfile.avatarId
      ? `${this._environment.apiInfo.apiBaseUrl}avatars/${context.currentlyLoggedInUserProfile.userProfile.avatarId}`
      : context.currentlyLoggedInUser.avatar;

    this.userId = context.userPermissions.userId;
    this.userProfile = context.currentlyLoggedInUserProfile.userProfile;
    this.loanStatus = context.globalConfig.loanStatus;
    this.user = {
      firstName: context.currentlyLoggedInUserProfile.userProfile.firstName,
      lastName: context.currentlyLoggedInUserProfile.userProfile.lastName,
      lastTimeLogin: context.currentlyLoggedInUser.lastTimeLogin,
      userImage: this.avatarUrl,
    };
    this.globalConfig = context.globalConfig;

    this.hasCallControlPanelActionBar = context.isCallControlPanelOpen;

    this.usingPanelType = "classic";
    // First check if the user is using RingCentral, if not, check if they are using Twilio or Classic
    const telephonyServices = context.currentlyLoggedInUserProfile.telephonyServices;
    if (telephonyServices && telephonyServices.length > 0) {
      const primaryTelephonyService = telephonyServices.find(ts => ts.isUserPrimaryNumber);
      if (primaryTelephonyService) {
        const useRingCentral = primaryTelephonyService.serviceType === "RingCentral";
        if (useRingCentral) {
          this.usingPanelType = "ringCentral";
        }
      }
    }

    if (this.usingPanelType !== "ringCentral") {
      const usingVoip = context.currentlyLoggedInUserProfile?.userProfile?.dialOutUsingVoip;
      if (usingVoip) {
        this.usingPanelType = "twilio";
      }
    }
  };

  private initializeConversationAutoRefreshTimer = () => {
    if (this._conversationAutoRefreshInterval) {
      clearInterval(this._conversationAutoRefreshInterval);
    }

    this._conversationAutoRefreshInterval = setInterval(async () => {
      this.refreshConversations();
    }, 600000);
  };

  private subscribeToEvents = () => {

    this._reconnectedSubscription = this._signalRService.reconnected$.subscribe(() => {
      this.refreshConversations();
    });

    this._conversationReminderSeenSubscription = this._conversationService.conversationReminderSeen.subscribe(
      (_conversation) => {
        // You have to put the seen one in "Others" group (unpinned or no active reminder ones), but then sort that group by mostRecentMessageDate
      }
    )

    this._conversationUpdatedSubscription =
      this._conversationService.conversationUpdated.subscribe(
        (conversation) => {

          // Find the parent group for the incoming conversation
          const parentGroup = this.allConversations.find(group =>
            group.conversations?.some(c => c.conversationId === conversation.conversationId)
          );
          if (parentGroup) {
            // Replace parent with convo, keep and sort children
            conversation.isActive = parentGroup.isActive;
            conversation.conversations = _.orderBy(parentGroup.conversations, ['mostRecentMessageDate'], ['desc']);
            const parentIdx = this.allConversations.indexOf(parentGroup);
            if (parentIdx > -1) {
              this.allConversations.splice(parentIdx, 1); // Remove the old conversation at parentIdx
              this.allConversations.unshift(conversation); // Add the new conversation to the top
            }
          } else {
            this.populateConversationColors(conversation);
            this.allConversations.unshift(conversation);
          }

          this.allConversations = [...this.allConversations];
        }
      );

    this._borrowerChatRequestedSubscription = this._conversationService.borrowerChatRequested.subscribe(
      async (borrowerChat) => {
        let convo = this.allConversations.find(
          (chat) =>
            chat.borrowerId == borrowerChat.borrowerId &&
            chat.applicationId === borrowerChat.appId
        );

        if (!convo) {
          // if user has more then 1k conversations and this conversation hasn't been loaded, try to GET it from an API
          // used to get conversation clicking borrower mention
          if (borrowerChat.conversationId) {
            try {
              convo = await firstValueFrom(this._conversationService.getConversation(borrowerChat.conversationId));
            } catch (error) {
              this._notifyService.showError(error?.message || "Couldn't load conversation", 'Error!');
              return;
            }
          }

          // if conversation hasn't been found
          if (!convo) {
            //todo: call api to register conversation
            const newConversation = new Conversation();
            newConversation.assignedTo = this.userId;
            newConversation.applicationId = borrowerChat.appId;
            newConversation.conversationId =
              borrowerChat.borrMessage?.conversationId;
            newConversation.borrowerId = borrowerChat.borrowerId;
            newConversation.chatMedium = ChatMedium.BorrowerMessage;
            newConversation.mostRecentIncomingMessageDate = new Date();
            newConversation.mostRecentMessageDate = new Date();
            newConversation.lastReadDate =
              newConversation.mostRecentIncomingMessageDate;
            newConversation.isUnread = true;
            newConversation.externalName =
              borrowerChat.borrMessage?.senderDisplayName ||
              `Borrower (${borrowerChat.borrowerId})`;

            try {
              const res = await firstValueFrom(this._conversationService.saveConversation(newConversation));
              convo = res;
            } catch (error) {
              this._notifyService.showError(error?.message || "Couldn't save conversation", 'Error!');
              return;
            }
          }

          this.allConversations.unshift(convo);
        } else {
          if (convo.isHidden) {
            this._updateConversationHiddenStatus(convo, false);
          }
          convo.mostRecentMessageDate = new Date();
          convo.mostRecentMessagePreview =
            borrowerChat.borrMessage.plainTextContent ||
            convo.mostRecentMessagePreview;

          if (convo.isActive) {
            this._conversationService.addBorrowerMessageToChat(
              borrowerChat.borrMessage
            );
          } else {
            convo.isUnread = true;
          }
          // Put this conversation to the top of the list
          const index = this.allConversations.indexOf(convo);
          if (index > -1) {
            this.allConversations.splice(index, 1);
            this.allConversations.unshift(convo);
          }
        }

        if (!borrowerChat.external) {
          this.allConversations.forEach((x) => (x.isActive = false));
        }

        this.doInitializeConversationsWithSavedFilters = true;

        if (!this._conversationsDrawerOpened && borrowerChat.openDrawer) {
          convo.isActive = true;
          this._openConversationDrawer(true);
        }

        this.allConversations = [...this.allConversations];
      }
    );

    this._agentChatRequestedSubscription = this._conversationService.agentChatRequested.subscribe(
      async (agentChat) => {
        let convo = this.allConversations.find(
          (chat) =>
            chat.agentId == agentChat.agentId &&
            chat.applicationId === agentChat.appId
        );

        if (!convo) {
          //todo: call api to register conversation
          const newConversation = new Conversation();
          newConversation.assignedTo = this.userId;
          newConversation.applicationId = agentChat.appId;
          newConversation.conversationId =
            agentChat.agentMessage?.conversationId;
          newConversation.agentId = agentChat.agentId;
          newConversation.chatMedium = ChatMedium.AgentMessage;
          newConversation.mostRecentIncomingMessageDate = new Date();
          newConversation.mostRecentMessageDate = new Date();
          newConversation.lastReadDate =
            newConversation.mostRecentIncomingMessageDate;
          newConversation.isUnread = true;
          newConversation.externalName =
            agentChat.agentMessage?.senderDisplayName ||
            `Agent (${agentChat.agentMessage})`;

          try {
            const res = await firstValueFrom(this._conversationService.saveConversation(newConversation));
            convo = res;
          } catch (error) {
            this._notifyService.showError(error?.message || "Couldn't save conversation", 'Error!');
            return;
          }

          this.allConversations.unshift(convo);
        } else {
          if (convo.isHidden) {
            this._updateConversationHiddenStatus(convo, false);
          }
          convo.mostRecentMessageDate = new Date();
          convo.mostRecentMessagePreview =
            agentChat.agentMessage.plainTextContent ||
            convo.mostRecentMessagePreview;

          if (convo.isActive) {
            this._conversationService.addAgentMessageToChat(
              agentChat.agentMessage
            );
          } else {
            convo.isUnread = true;
          }
          // Put this conversation to the top of the list
          const index = this.allConversations.indexOf(convo);
          if (index > -1) {
            this.allConversations.splice(index, 1);
            this.allConversations.unshift(convo);
          }
        }

        if (!agentChat.external) {
          this.allConversations.forEach((x) => (x.isActive = false));
        }

        this.doInitializeConversationsWithSavedFilters = true;

        if (!this._conversationsDrawerOpened && agentChat.openDrawer) {
          convo.isActive = true;
          this._openConversationDrawer(true);
        }

        this.allConversations = [...this.allConversations];
      }
    );

    this._internalChatRequestedSubscription = this._conversationService.internalChatRequested.subscribe(
      async (internalChat) => {
        let convo = this.allConversations.find(
          (chat) =>
            chat.chatMedium == 'InternalMessage' &&
            chat.applicationId == internalChat.appId
        );

        if (!convo) {
          //todo: call api to register conversation
          const newConversation = new Conversation();
          newConversation.assignedTo = this.userId;
          newConversation.applicationId = internalChat.appId;
          newConversation.chatMedium = ChatMedium.InternalMessage;
          newConversation.mostRecentIncomingMessageDate = new Date();
          newConversation.mostRecentMessageDate = new Date();
          newConversation.isUnread = true;
          newConversation.lastReadDate =
            newConversation.mostRecentIncomingMessageDate;
          newConversation.externalName =
            internalChat.borrMessage?.senderDisplayName;

          try {
            const res = await firstValueFrom(this._conversationService.saveConversation(newConversation));
            convo = res;
          } catch (error) {
            this._notifyService.showError(error?.message || "Couldn't save conversation", 'Error!');
            return;
          }

          this.allConversations.unshift(convo);
        } else {
          if (convo.isHidden) {
            this._updateConversationHiddenStatus(convo, false);
          }
          convo.mostRecentMessageDate = new Date();
          convo.mostRecentMessagePreview =
            internalChat.borrMessage.plainTextContent ||
            convo.mostRecentMessagePreview;
          if (convo.isActive) {
            this._conversationService.addBorrowerMessageToChat(
              internalChat.borrMessage
            );
          } else {
            convo.isUnread = true;
          }
        }

        if (!internalChat.external) {
          this.allConversations.forEach((x) => (x.isActive = false));
        }

        if (!this._conversationsDrawerOpened && internalChat.openDrawer) {
          convo.isActive = true;
          this._openConversationDrawer();
        }

        this.allConversations = [...this.allConversations];
      }
    );

    this._smsChatRequestedSubscription = this._conversationService.smsChatRequested.subscribe((smsChat) => {
      this.onSmsChatRequested(smsChat);
    });

    this._contextChangesForLoaninfoSubscription = this._applicationContextService.loanInfoChanges.subscribe(({ context }) => {
      this.insideLoanContext = false;
      if (context.application) {
        this.insideLoanContext = true;
      }
    });

    this._contextChangesSubscription = this._applicationContextService.changes.subscribe((context) => {
      if (context) {
        this.initializeFromContext(context);
      }
    });

    this._contextSubscription = this._applicationContextService.context.subscribe((context) => {
      this.initializeFromContext(context);
      this.checkUserFromNumber(context);

      this._loanUpdateCoordinator.initialize();
      this._signalRService.run(context);
      this._firebaseService.run(context);

      this.isCompany2 = context.userPermissions.companyId == 2;
      this.loadBrandOverrides(context);

      if (context.isCompanyPulseProcessing) {
        const body: HTMLBodyElement | null = document.querySelector('#loda-body');
        if (body) {
          body.classList.remove('pulse-processing-tpo-background');
        }
      }
    });

    this._subscriptionTologgedInUserChanges = this._applicationContextService.loggedInUserChanges.subscribe(context => {
      this.initializeFromContext(context);
    });

    this._subscriptionToApplicationContextChanges = this._applicationContextService.callControlPanelStatChanges.subscribe(context => {
      this.initializeFromContext(context);
    });
  };

  private loadBrandOverrides = (context: ApplicationContext) => {
    const company = context.globalConfig.company.find(
      (c) => c.companyId == context.userPermissions.companyId
    );
    if (company?.companyGUID) {
      this.overrideCssUrl =
        this._environment.apiInfo.publicApiBaseUrl +
        `api/PublicApi/custom-css/${company.companyGUID}/Admin`;
    }

    this.brandLogoUrl =
      this._environment.apiInfo.apiBaseUrl +
      `company/br/logo/${context.userPermissions.companyId}`;

    this.brandSmallLogoUrl =
      this._environment.apiInfo.apiBaseUrl +
      `company/br/small/${context.userPermissions.companyId}`;
  };

  private checkUserFromNumber = (context: ApplicationContext) => {
    this.currentUserPhoneNumber = Utils.getActiveTelephonyService(
      context.currentlyLoggedInUserProfile.telephonyServices
    )?.fromPhoneNumber;
    const isShownPhoneMessage = this._localStorageService.getItem(
      'isShownPhoneMessage'
    );
    if (!this.currentUserPhoneNumber && !isShownPhoneMessage) {
      this._notifyService.showWarning(
        'User phone number was not defined',
        'Warning'
      );
      this._localStorageService.setItem('isShownPhoneMessage', true);
    }
  };

  private _openConversationDrawer = (doInitializeConversationsWithSavedFilters: boolean = false) => {
    this.doInitializeConversationsWithSavedFilters = doInitializeConversationsWithSavedFilters;
    document.body.classList.add('body-no-scroll');
    this._drawerService.show('conversationsDrawer', 10);
    this._conversationsDrawerOpened = true;
  };

  private getConversations = (userId?: string) => {
    this.conversationsUserId = userId || this.userProfile.userCompanyGuid;
    this.allConversations = [];
    this._conversationService
      .getConversationsForUser(this.conversationsUserId, 1, 1000)
      .subscribe({
        next: (chats) => {
          if (chats?.records?.length > 0) {
            this.allConversations = this.prepareConversationItemsForList(
              chats?.records
            );
          }
          this.initializeConversationAutoRefreshTimer();
        },
        error: (error) => {
          this._notifyService.showError(
            error?.message || "Couldn't load conversations",
            'Error'
          );
        },
      });
  };

  private refreshConversations = (userId?: string) => {
    this.conversationsUserId = userId || this.userProfile.userCompanyGuid;
    this._conversationService
      .getConversationsForUser(this.conversationsUserId, 1, 1000, 11)
      .subscribe({
        next: (newChats) => {
          if (newChats?.records?.length > 0) {
            const newConversationsToAppend = [];
            newChats.records.forEach((chat) => {
              const existing = this.allConversations.find(
                (c) => c.conversationId == chat.conversationId
              );
              if (!existing) {
                newConversationsToAppend.push(chat);
              }
            });
            if (newConversationsToAppend.length > 0) {
              const newConversationListItems =
                this.prepareConversationItemsForList(newConversationsToAppend);
              const existingConversations = [...this.allConversations];
              let allConversationsAfterRefresh = existingConversations.concat(
                newConversationListItems
              );
              // Order them by the most recent message date
              allConversationsAfterRefresh = _.orderBy(
                allConversationsAfterRefresh,
                ['mostRecentMessageDate'],
                ['desc']
              );
              this.allConversations = allConversationsAfterRefresh;
            }
          }
        },
        error: (error) => {
          console.log(error);
          this._notifyService.showError(
            error?.message || "Couldn't refresh conversations",
            'Error'
          );
        },
      });
  };

  private prepareConversationItemsForList = (
    conversations: Array<Conversation>
  ): Array<Conversation> => {
    const conversationItems: Conversation[] = [];
    const now = new Date();

    const conversationsWithRemindersThatAreDue = _.orderBy(
      conversations.filter(c => c.reminderAt && new Date(c.reminderAt).getTime() <= now.getTime()),
      ['mostRecentMessageDate'],
      ['desc']
    );

    const pinnedConversations = _.orderBy(
      conversations.filter(c => c.isPinned && !(c.reminderAt && new Date(c.reminderAt).getTime() <= now.getTime())),
      ['mostRecentMessageDate'],
      ['desc']
    );

    const otherConversations = _.orderBy(
      conversations.filter(c =>
        !c.isPinned && !(c.reminderAt && new Date(c.reminderAt).getTime() <= now.getTime())
      ),
      ['mostRecentMessageDate'],
      ['desc']
    );

    const allConversationsSortedByMostRecentMessageDate = [
      ...conversationsWithRemindersThatAreDue,
      ...pinnedConversations,
      ...otherConversations
    ];

    const smsConversations = allConversationsSortedByMostRecentMessageDate.filter(
      (c) =>
        c.chatMedium === ChatMedium.Sms &&
        c.participants &&
        c.participants.some(
          (p) => p.participantType === ParticipantType.External && p.phoneNumber
        )
    );

    const smsConversationGroupedByExternalParticipants = _.groupBy(
      smsConversations,
      (c) => {
        const externalParticipants = _.orderBy(
          c.participants.filter(
            (p) => p.participantType === ParticipantType.External
          ),
          ['phoneNumber'],
          ['asc']
        );
        const groupIdenfier = externalParticipants
          .map((p) => removeUsPhonePrefix(p.phoneNumber))
          .join(' ');
        return groupIdenfier;
      }
    );

    const smsChatConversationsAccountedFor: string[] = [];

    allConversationsSortedByMostRecentMessageDate.forEach((conversation) => {
      this.populateConversationColors(conversation);
      const externalParticipants = _.orderBy(
        conversation.participants.filter(
          (p) => p.participantType === ParticipantType.External
        ),
        ['phoneNumber'],
        ['asc']
      );
      const groupIdenfier = externalParticipants
        .map((p) => removeUsPhonePrefix(p.phoneNumber))
        .join(' ');

      // Handle SMS conversations differently, since they can be grouped by external participants and done with the same user using different numbers
      if (conversation.chatMedium == ChatMedium.Sms) {
        if (!smsChatConversationsAccountedFor.includes(groupIdenfier)) {
          if (
            Object.prototype.hasOwnProperty.call(
              smsConversationGroupedByExternalParticipants,
              groupIdenfier
            ) &&
            smsConversationGroupedByExternalParticipants[groupIdenfier]
          ) {
            conversation.conversations =
              smsConversationGroupedByExternalParticipants[groupIdenfier];
            smsChatConversationsAccountedFor.push(groupIdenfier);
            conversationItems.push(conversation);
          }
        }
      } else {
        conversationItems.push(conversation);
      }
    });
    return conversationItems;
  };

  private populateConversationColors = (conversation: Conversation) => {
    if (!conversation.contactAvatarColor) {
      conversation.contactAvatarColor = ColorUtils.normalizedColorFromString(
        conversation.externalName || uuidv4()
      );
    }

    if (conversation.chatMedium == 'InternalMessage') {
      conversation.contactAlias = '--';
    } else if (
      conversation.externalName &&
      conversation.externalName.length > 3
    ) {
      conversation.contactAlias = conversation.externalName
        .match(/(\b\S)?/g)
        .join('')
        .match(/(^\S|\S$)?/g)
        .join('')
        .toUpperCase();
    } else if (
      conversation.participants.some(
        (p) => p.participantType === ParticipantType.External && p.name
      )
    ) {
      const externalParticipant = conversation.participants.find(
        (p) => p.participantType === ParticipantType.External
      );
      conversation.contactAlias = externalParticipant.name
        .match(/(\b\S)?/g)
        .join('')
        .match(/(^\S|\S$)?/g)
        .join('')
        .toUpperCase();
    } else {
      conversation.contactAlias = '??';
    }
  };

  private _updateConversationHiddenStatus(
    conversation: Conversation,
    status: boolean
  ) {
    conversation.isHidden = status;
    if (!conversation.conversationId) {
      return;
    }
    this._conversationService
      .changeHiddenStatus(conversation.conversationId, status)
      .subscribe();
  }

  private isLatestActivationToken = (token: number | null): boolean =>
    !!token && token === this._conversationService.latestActivationToken;

  /** Asks the conversation list to select this conversation, unless a newer request has been made since. */
  private requestConversationActivation = (token: number | null, conversationId: number) => {
    if (!this.isLatestActivationToken(token)) {
      return;
    }
    this.conversationActivationRequest = { token, conversationId };
  };

  private findConversationListItem = (conversationId: number): Conversation | undefined =>
    this.allConversations.find(c =>
      c.conversationId === conversationId || c.conversations?.some(child => child.conversationId === conversationId));

  private async updateConversationForId(convo: Conversation, smsChat: SmsChatRequestedModel) {
    if (!convo.agentId && !convo.applicationId && !convo.borrowerId && !convo.leadId && !!smsChat.conversationTargetPersonContext) {
      const originalContext = {
        agentId: convo.agentId,
        applicationId: convo.applicationId,
        borrowerId: convo.borrowerId,
        leadId: convo.leadId,
      };
      convo.agentId = smsChat.conversationTargetPersonContext?.agentId || null;
      convo.applicationId = smsChat.conversationTargetPersonContext?.applicationId || null;
      convo.borrowerId = smsChat.conversationTargetPersonContext?.borrowerId || null;
      convo.leadId = smsChat.conversationTargetPersonContext?.leadId || null;

      const subConvos = convo.conversations ? [...convo.conversations] : [];
      delete convo.conversations;

      // Call API to update conversation in DB
      this._spinnerService.show();
      try {
        const newConvo = await firstValueFrom(this._conversationService.updateConversation(convo));
        const convoIndex = this.allConversations.findIndex(c => c.conversationId === convo.conversationId);
        if (convoIndex > -1) {
          // Keep the row's grouped conversations on its replacement, or they drop out of the list.
          if (subConvos.length > 0) {
            newConvo.conversations = subConvos.map(c => c.conversationId === newConvo.conversationId ? newConvo : c);
          }
          this.allConversations.splice(convoIndex, 1); // Remove the old conversation
          this.allConversations.unshift(newConvo); // Add the new conversation to the top
          this.allConversations = [...this.allConversations];
        }
      } catch(e) {
        console.log(e);
        Object.assign(convo, originalContext); // Not saved, so don't show it as linked
      } finally {
        convo.conversations = [...subConvos];
        this._spinnerService.hide();
      }
    }
  }
}

export class ConversationTargetPersonContext {
  applicationId?: number;
  borrowerId?: number;
  leadId?: number;
  agentId?: number;
}
